module.exports = __webpack_public_path__ + "assets/img/my-vip-bottom-note3.6a1928f3.png";